export const getDatacenterName = (dcId, dataCenters) => {
  const { properties = {} } = dataCenters.find(({ id }) => id === dcId) || {};
  return properties.name;
};
